import { defineStore } from 'pinia';
import api from "@/services/api.js";

export const useStore = defineStore({
  id: 'store',
  state: (): any => {
    return {
      faculdadeid: -1,
      cursoid: -1,
      testemunhos: [],
      currentTestemunhoId: -1,
      currentTestemunho: null,
      testemunhosForCurso: []
    }
  },
  getters:{
    
  },
  actions: {
    getTestemunhoByName(name){
      return api.getTestemunhosByName(name).
        then(testemunho => {
          this.currentTestemunho = testemunho;
          this.currentTestemunho.Questionario = Object.keys(testemunho.Questionario).map(
            (k) => testemunho.Questionario[k]
          );
          return true
        }).
        catch(error => {
          throw error;
        });
    },
    getTestemunhosForCurso(cursoid){
      this.testemunhosForCurso = [];
      api.getTestemunhosForCurso(cursoid).
        then(testemunhos => {
          this.testemunhosForCurso = testemunhos.map(el => {
            return {
              ...el,
              name: el?.Name || el.name
            }
          });
        }).
        catch(error => {
          throw error;
        });
    },
    getTestemunhos(){
      api.getTestemunhos(this.cursoid,this.faculdadeid,'pt').
        then(data => {
          this.testemunhos = data;
        }).
        catch(error => {
          console.log(error);
        });
    },
    selectTestemunho(testemunho){
      this.currentTestemunhoId = testemunho.id;
      this.getTestemunhoByName(testemunho.name)
      this.getTestemunhosForCurso(testemunho.cursoid);
    },
    setTestemunhoToNull(){
      this.currentTestemunhoId = -1;
      this.currentTestemunho = null;
    }
  }
})